import { cn } from '@/shared/utils';
import CompanySmallIcon from '@/shared/assets/company-small-icon.svg?react';

type Props = {
  initial: string;
  isCorporate: boolean;
  isVerified: boolean;
  className?: string;
};

export function UserAvatar({
  initial,
  isCorporate,
  isVerified,
  className,
}: Props) {
  return (
    <div className={cn('relative shrink-0', className)}>
      <div className="size-[2rem] rounded-full bg-primary text-background flex items-center justify-center text-[1rem] leading-[2rem] font-bold select-none">
        {isCorporate ? <CompanySmallIcon className="size-[1rem]" /> : initial}
      </div>

      {!isVerified && (
        <img
          src="/assets/warning-status-icon.svg"
          alt=""
          className="size-[0.9rem] absolute bottom-[-0.2rem] right-[-0.2rem]"
        />
      )}
    </div>
  );
}
